





































	import { Vue, Component, Prop, Caret, Watch } from "../../Infrastructure/CorBase/CoreBase";



	@Component
	export default class BaseTLTextArea extends Vue {
		@Prop({ type: String, required: true, default: "" }) id?: string; //id
		@Prop({ type: String, required: true, default: "" }) value!: string; //hlavni text
		@Prop({ required: false }) searchAll: any; //seznam prvku ktere se zobrazi v napovede
		@Prop({ type: Boolean, required: false, default: false }) required?: boolean; //povinne
		@Prop({ type: Boolean, required: false, default: false }) readonly?: boolean; //pouze čteni
		@Prop({ type: Number, required: false, default: 2 }) rows?: number; //počet řadků
		@Prop({ type: String, required: false, default: "" }) textLabel?: string;//popis před
		@Prop({ type: String, required: false, default: "0" }) textLabelWidth?: string;//šířka popisu
		@Prop({ type: String, required: false, default: "0" }) inputWidth?: string;// šířka input pole
		@Prop({ type: Boolean, required: false, default: false }) notLabel?: boolean; //pouze prvek bez popisku - zatim jen dropdownlist
		@Prop({ type: String, required: false, default: "20" }) maxlength?: number;//TODO funguje pouze na text
		@Prop({ type: Boolean, required: false, default: false }) started?: boolean; //lze jiz s tim pracovat 
		@Prop({ type: Boolean, required: false, default: true }) addColon?: boolean; //pridani dvoutecky za nazev 

		//moznosti napovedy - vse VZOR
		//searchAll = [{ id: 1, text: 'Ales' }, { id: 2, text: 'Jan' }, { id: 3, text: 'Mirek' }, { id: 4, text: 'Dan' }
		//,{ id: 5, text: 'Alena' },];





        textLabelNormal() {
            var textWith = this.addColon == true ? this.textLabel + ":" : this.textLabel;
            return textWith;
        }

		//subselect napovedy
		search = [{ id: -1, text: '' }];
		//vybrany prvek z napovedy
		selectSearch = { id: -1, text: '' };
		indexSelectSearch = 0;

		referralSearch = [{ id: 1, text: 'aaa' }, { id: 2, text: 'dost' }];
		inputValIdTemp = 0;

		inputVal = '';
		textSuggestionWidth = 300;
		name = "name";

        private timerSetting = 0;

		//pozice napovedy
		leftPosition = '35px';
		topPosition = '20px';
		//zobrazeni napovedy
		showSuggestion = false;

		//opusteni textarea - je treba s timerem protoze jinak si nevyberu
		textSuggestionControlBlur() {
		//	this.isMenuClick = this.showSuggestion = false;
            this.timerSetting = setTimeout(() => {
				this.showSuggestion = false;
            }, 200);
		}


		isMenuClick = false;

		
		clictToOther() {
			this.showSuggestion = false;
        }


		get model() {
			return this.inputVal;
		}
		set model(value: any) {
			this.inputVal = value;
		}


		//nastaveni po kliku
		clickToSuggestion(item: any) {
			this.isMenuClick = true;
            var indexLast = this.inputVal.substring(0, this.index+1).lastIndexOf('@') + 1;

			//nalezeni prvni mezery po focusu pokud je potreba 
			var subFromNew = this.inputVal.substring(indexLast);
            var indexGap = subFromNew.indexOf(' ');			
            var nahrada = subFromNew.substring(0, indexGap);
            var lengthChange = nahrada.length;
			if (lengthChange > 0) {
				this.inputVal = this.inputVal.substr(0, indexLast) + item.text  + this.inputVal.substr(indexLast + lengthChange);
			}
			else {
                this.inputVal = this.inputVal.substr(0, indexLast) + item.text + ' ' + this.inputVal.substr(indexLast + lengthChange);
            }

			var element = document.getElementById(String(this.id));
			if (element != null) {
				element.focus();
			}
			this.showSuggestion = false;
		}

		lastSearchLength = 0; //pocet poslednich vysledku
		index = 0; //aktualni pozice v nabídce

		//pri stisku klavesy - filtruje se nabídka
		keyDown(event: any) {
			if (this.showSuggestion) {

				if (event.key == 'ArrowDown') {
					if (this.search.length > this.indexSelectSearch + 1) {
						this.indexSelectSearch++;
						this.selectSearch = this.search[this.indexSelectSearch];
						this.inputValIdTemp = this.selectSearch.id;
					}
					event.returnValue = false;
				}
				else if (event.key == 'ArrowUp') {
					if (this.indexSelectSearch > 0) {
						this.indexSelectSearch--;
						this.selectSearch = this.search[this.indexSelectSearch];
						this.inputValIdTemp = this.selectSearch.id;
					}
					event.returnValue = false;
				}
				else if (event.key == 'Enter') {
					this.clickToSuggestion(this.search[this.indexSelectSearch]);
					event.returnValue = false;
				}

			}
		}

		//aktualni stisk
		//zjisteni k cemu se bude pridavat napoveda
		getActualWrite(event: any, text: string) {
			this.index = event.target.selectionStart;
			var element = document.getElementById(String(this.id)) as HTMLTextAreaElement;
			//zjisteni pozice v textarea
			if (element) {
				var pozice = element.getClientRects();
				var relative = Caret.getRelativePosition(element);
				var absolute = Caret.getAbsolutePosition(element);
				this.leftPosition = relative.left + 'px';
  			this.topPosition = relative.top - pozice[0].height + 20 + 'px';
			}

			var indexLast = text.substring(0, this.index + 1).lastIndexOf('@');
			var subString = text.substring(indexLast, this.index);
			var find = subString.substring(1).toLocaleLowerCase();
			this.search = this.searchAll.filter((c: any) => (c.text as string).toLocaleLowerCase().indexOf(find) != -1);

			this.showSuggestion = this.search.length > 0;
			if (indexLast != -1) {
				this.search = this.searchAll.filter((c: any) => (c.text as string).toLocaleLowerCase().indexOf(find) != -1);
				if (this.lastSearchLength != this.search.length && this.search.length > 0) {
					this.selectSearch = this.search[0];
					this.indexSelectSearch = 0;
					this.selectSearch = this.search[this.indexSelectSearch];
					this.inputValIdTemp = this.selectSearch.id;
					this.lastSearchLength = this.search.length;
				}
				this.showSuggestion = this.search.length > 0;
			}
			else {
				this.showSuggestion = false;
			}
		}

		getReferralSuggestion(event: any, neco: any) {
			this.getActualWrite(event, neco);
		}

		@Watch('value')
		onPropertyChangedPrrr(value: string, oldValue: string) {
			if (value !== oldValue ) {
				this.inputVal = this.value;
			}
		}

		@Watch('inputVal')
		onPropertyChanged(value: string, oldValue: string) {
			if (value !== oldValue && this.started) {
				var a = value[this.index];
				if (this.showSuggestion == false && a == '@') {
					this.showSuggestion = true;
					this.search = this.searchAll;
					this.selectSearch = this.search[0];
					this.indexSelectSearch = 0;
					this.selectSearch = this.search[this.indexSelectSearch];
					this.inputValIdTemp = this.selectSearch.id;					
				}
				this.$emit('change', this.inputVal);
			}
		}

		get inputClass() {
			return {
				"inputAutomcompleteTextArea": true,
				"inputDetailTextAreaAutocompleteIsEdit": !this.readonly,
				"inputDetailTextAreaNoEdit": this.readonly
			}
		}

        validate() {
           
			var result = true;
            if ( this.required == false || this.readonly) {
                return null;
			}
			result = this.required ? this.value.length > 0 : true;
            this.$emit('isCorrect', result);
            return result;
        }
	}
